import React from 'react';
import lightVersion from '../../images/icons/ui-images/light/light-arrow.svg';

function ArrowIcon() {
  return (
    <img src={lightVersion}/>
  )
}

export default ArrowIcon;
